import { useEffect, useState } from "react";
import api from "../../lib/api";
import { fmtDate } from "../../lib/status";
import { toast } from "sonner";

export default function Tickets() {
    const [tickets, setTickets] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [form, setForm] = useState({
        subject: "",
        description: "",
        priority: "medium",
    });

    const load = async () => {
        const { data } = await api.get("/tickets");
        setTickets(data);
    };

    useEffect(() => {
        load();
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        try {
            await api.post("/tickets", form);
            toast.success("Ticket raised. We'll get back to you soon.");
            setForm({ subject: "", description: "", priority: "medium" });
            setShowForm(false);
            await load();
        } catch (e) {
            toast.error("Could not raise ticket");
        }
    };

    return (
        <div className="space-y-8">
            <div className="flex items-end justify-between">
                <div>
                    <div className="lx-label text-[#B2912A]">Support</div>
                    <h1 className="font-serif text-4xl text-[#180A21]">
                        How can we <span className="italic">help</span>?
                    </h1>
                </div>
                <button
                    onClick={() => setShowForm((v) => !v)}
                    data-testid="ticket-new-btn"
                    className="lx-btn-primary px-5 py-2.5"
                >
                    {showForm ? "× Close" : "+ New ticket"}
                </button>
            </div>

            {showForm && (
                <form onSubmit={submit} className="lx-card p-7 space-y-4">
                    <input
                        placeholder="Subject"
                        value={form.subject}
                        onChange={(e) => setForm({ ...form, subject: e.target.value })}
                        required
                        className="lx-input"
                        data-testid="ticket-subject"
                    />
                    <textarea
                        placeholder="Describe your issue…"
                        value={form.description}
                        onChange={(e) => setForm({ ...form, description: e.target.value })}
                        required
                        rows={4}
                        className="lx-input"
                        data-testid="ticket-description"
                    />
                    <select
                        value={form.priority}
                        onChange={(e) => setForm({ ...form, priority: e.target.value })}
                        className="lx-input"
                    >
                        <option value="low">Low priority</option>
                        <option value="medium">Medium priority</option>
                        <option value="high">High priority</option>
                        <option value="urgent">Urgent</option>
                    </select>
                    <button
                        type="submit"
                        data-testid="ticket-submit-btn"
                        className="lx-btn-gold px-6 py-3"
                    >
                        Submit ticket
                    </button>
                </form>
            )}

            <div className="space-y-3">
                {tickets.length === 0 && (
                    <div className="text-center py-12 text-[#555]">
                        No tickets. Hope you're enjoying our service!
                    </div>
                )}
                {tickets.map((t) => (
                    <div
                        key={t.id}
                        className="lx-card p-5"
                        data-testid={`ticket-row-${t.ticket_number}`}
                    >
                        <div className="flex items-center gap-3 mb-2 flex-wrap">
                            <span className="lx-label text-[#B2912A]">{t.ticket_number}</span>
                            <span
                                className="px-2 py-0.5 text-[10px] uppercase tracking-wider border"
                                style={{
                                    color:
                                        t.priority === "urgent"
                                            ? "#FF2D55"
                                            : t.priority === "high"
                                              ? "#FF9500"
                                              : "#555",
                                    borderColor: "#E5E2DC",
                                }}
                            >
                                {t.priority}
                            </span>
                            <span className="text-xs text-[#555]">{t.status}</span>
                        </div>
                        <div className="font-serif text-lg text-[#180A21]">{t.subject}</div>
                        <div className="text-sm text-[#555] mt-1 line-clamp-2">
                            {t.description}
                        </div>
                        <div className="text-xs text-[#555] mt-2">
                            Raised {fmtDate(t.created_at)}
                        </div>
                    </div>
                ))}
            </div>
            <style>{`.lx-input{width:100%;padding:.7rem 1rem;background:white;border:1px solid #E5E2DC;outline:none;transition:all 200ms ease;font-size:.875rem}.lx-input:focus{border-color:#D4AF37;box-shadow:0 0 0 1px #D4AF37}`}</style>
        </div>
    );
}
